import React from "react";
import Select from "react-select";
import Scrollbars from "react-custom-scrollbars";

const renderScrollbar = props => {
	return (
		<Scrollbars
			className="scroll_container"
			autoHeight={true}
			hideTracksWhenNotNeeded={true}
			renderTrackVertical={props => <div {...props} className="track_vertical" />}
			renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
		>
			{props.children}
		</Scrollbars>
	);
};

/**
 * @param {Boolean} fullWidth Indicates weather full width should be used
 * @param {Boolean} inline Indicates weather the select box should have display: inline-block
 */
const MySelect = ({ fullWidth, inline, transparent, ...props }) => {
	return (
		<Select
			className={`react_select ${fullWidth && "w-100"} ${inline && "inline"} ${transparent && "transparent"}`}
			classNamePrefix="react_select"
			placeholder="---"
			components={{ MenuList: renderScrollbar }}
			{...props}
		/>
	);
};

export default MySelect;
export { MySelect as Select };
